import Bugsnag from '@bugsnag/browser';
import { errorify } from './errorify';
/**
 *
 * @param obj - some inputted object
 * @param attrs - either a single string, number, or array of strings/numbers
 * @param base - a default value of any type that is passed into safelyGetAttributes in case an attribute is not found
 * @returns - some given attribute of an object/child object
 */
export const safelyGetAttributes = (
  obj: Object,
  attrs: string | number | Array<string | number>,
  base: unknown = null,
) => {
  try {
    let current = obj;
    if (!Array.isArray(attrs)) {
      attrs = [attrs];
    }
    for (let attr of attrs) {
      if (attr in Object(current)) {
        // @ts-expect-error
        current = current[attr];
      } else {
        return base;
      }
    }
    return current;
  } catch (e) {
    Bugsnag.notify(errorify(e));
    return base;
  }
};
